import React from "react";
import CandidatesList from "pages/CandidatesList";
import { Login } from "../features/login";
import CandidateAdd from "pages/CandidateAdd";
import CandidateView from "pages/CandidateView";
import CandidateParse from "pages/CandidateParse";
import CompaniesList from "pages/CompaniesList";
import CompanyView from "pages/CompanyView";
import LinqRequests from "features/linq-requests/LinqRequests";
import ExternalRecruitersManagement from "pages/ExternalRecruitersManagement";
import { PERMISSIONS } from "constants/roles";

export const routes = [
    {
        path: "/login",
        withLayout: false,
        withAuth: false,
        element: <Login />,
    },
    {
        path: "/",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.CANDIDATE_VIEW_LIST,
        element: <CandidatesList />,
    },
    {
        path: "/companies",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.COMPANY_VIEW_LIST,
        element: <CompaniesList />,
    },
    {
        path: "/requests",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.LINQ_REQUEST_VIEW_LIST,
        element: <LinqRequests />,
    },
    {
        path: "/external-recruiters-management",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.EXTERNAL_RECRUITER_VIEW_MANAGEMENT,
        element: <ExternalRecruitersManagement />,
    },
    {
        path: "/candidate/add/manual-fill",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.CANDIDATE_CREATE_MANUAL,
        element: <CandidateAdd />,
    },
    {
        path: "/candidate/add/parse-linkedin",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.CANDIDATE_CREATE_PARSED,
        element: <CandidateParse />,
    },
    {
        path: "/candidate/add/parse-cv",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.CANDIDATE_CREATE_PARSED,
        element: <CandidateParse />,
    },
    {
        path: "/candidate/view/:id",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.CANDIDATE_VIEW_SINGLE,
        element: <CandidateView />,
    },
    {
        path: "/company/view/:id",
        withLayout: true,
        withAuth: true,
        permissions: PERMISSIONS.COMPANY_VIEW_SINGLE,
        element: <CompanyView />,
    },
];
